import { styled } from '@clickcease/cc-client-components-lib'

export const BotMitigationDataStyled = styled('div', {
  display: 'flex',

  '> div': {
    marginRight: '$4',
  },
})
